export interface relatedRestaurants{
  count: number,
  page: number,
  data: DeliveryDiscoveryRelatedRestaurant[]
}
interface DeliveryDiscoveryRelatedRestaurant{
  uuid: string,
  data: object
}
export interface Basket {
  loading?:BasketLoadersEnum,
  visible: boolean;
  showCreateBasket:boolean;
  showAreaZone:boolean;
  disableSubmit: boolean;
  uuid: string;
  didToggleDeliveryTime?:boolean;
  ref: {
    restaurant: BasketRestaurant;
    branch: BasketBranch;
    address?: UserAddress;
    card?: Card;
    promo?: PromoData;
    zoneUUID:string;
    areaUUID:string;
  }; 
  data: {
    receipt: Receipt;
    memberReceipt: Receipt;
    categories: BasketCategory[];
    paymentType:string
    minimumOrderValue:number;
    error?: BasketErrorEnum;
    basketDataExist:boolean;
    isLocked:boolean,
    deliveryTime:string
  };
  payment: {
    method: string,
    cardUUID: string,
    paymentTypeEnum: {
      CASH_ON_DELIVERY: string,
      CREDIT_CARD: string
    },
  },
  checkout: Checkout,
  errorsEnumToText: MapEnumToText,
  basketItemErrors: MapEnumToText
}

export interface MapEnumToText {
  [errorEnum: string]: string // BasketItemErrorEnum
}

export enum BasketLoadersEnum{
  addItem ="Adding Item",
  editItem="Editing Item",
  getItems="Getting Basket",
  removeItem="Removing Item",
  removeAll="Deleting Basket",
  address="Loading Addresses",
  promo="Adding Promo",
  unlock="unlocking Basket",
  checkoutLoadingData='checkout load data',
  myOrdersLoadingData='my order load data',
  applyWallet="Applying Wallet",
}
/*****Checkout*****/
interface confirmedOrderRef{
  restaurantLogo:string,
  restaurantName:string,
  restaurantUUID:string
}
interface confirmedOrder{
  orderUUID:string,
  data:orderConfirmationData,
  ref:confirmedOrderRef
}
interface orderConfirmationData{
  categories:BasketCategory[],
  createdAt:string,
  estimatedDeliveryTime:string,
  orderShortCode: string,
  orderStateEnum:string,
  paymentTypeEnum:string,
  promoDetails:PromoData,
  receipt:Receipt
}
interface timeBlamed{
  at:string,
  by:string
}
interface orderConfirmationTrace{
  created:timeBlamed,
  updated:timeBlamed
}
interface orderConfirmation{
  code:string,
  error?:string,
  order:confirmedOrder,
  
}
interface Checkout {
  currentStep: number,
  steps: CheckoutStep[],
  showOrderSuccess: boolean, // checkoutDone in old model
  showCheckoutModal: boolean,
  placeOrderError: string,
  confirmation?:orderConfirmation
}
interface CheckoutStep{
  step: number,
  title: string,
  optional: boolean
}

/**********Start Basket Refs***********/
interface BasketRestaurant {
  uuid: string;
  name: string;
  shortCode: string;
  logo?: string;
  acceptPromo: boolean;
  onlinePayment?: boolean;
}
interface BasketBranch {
  uuid: string;
  shortCode: string;
  ramadanSettings:RamadanSettings
}
interface RamadanSettings{
  orderIftarEnabled:Boolean,
  orderNowEnabled:Boolean,
  iftarTime:string
}
interface PromoData {
  code:string,
  promoUUID: string;
  discount: number;
  minOrderValue: number;
  maxMoneyValue: number;
} 
export interface PromoRequest{
  code:string,
  errors?:string 
}
/*****Address*******/
interface UserAddress {
  uuid: string;
  ref: UserAddressRef;
  data: UserAddressData;
}
interface UserAddressRef {
  cityUUID: string;
  areaUUID: string;
  zoneUUID: string;
}
interface UserAddressData {
  fullName: string;
  phoneNumber: string;
  location?: Location;
  address: string;
  deliveryInstructions?: string;
  buildingNumber: string;
  floor?: string;
  apartmentNumber?: string;
  companyName?: string;
  company: boolean;
  default: boolean;
  verified: boolean;
}

export interface BasketUserAddresses{
  applicable:UserAddress[],
  notApplicable:UserAddress[]
}

/*lock-unlock*/
export interface basketLocked{
locked:boolean;
}
/*****Credit Card*******/
interface Card {
  uuid: string;
  data: CardData;
}
interface CardData {
  token?: string;
  default: boolean;
  expiryDate: string;
  number: string;
  cardType: CardTypeEnum;
}
/*********Credit Card* "/card" *******/
interface CreditCardsListResponse { 
  data: Card[]
}
enum CardTypeEnum {
  VISA = "VISA",
  MASTERCARD = "MASTERCARD",
  AMEX = "AMEX",
  MADA = "MADA"
}

/**********End Basket Refs***********/
/*************Start Basket Data*************/
/*****Reciept*******/
interface Receipt {
  subTotal: number;
  tax: number;
  deliveryFee: number;
  deliveryCharges: {
    deliveryFees: number;
    serviceFees: number;
  };
  total: number;
  taxOnDelivery: boolean;
  totalBeforeDiscount?: number;
  paidWithWallet: boolean;
  walletDiscount: number;
} 
/*****Basket Items Categorized[used in view basket]*******/
export interface BasketCategory {
  categoryUUID: string;
  name: string; 
  items: BasketItem[];
}
export interface BasketItem {
  basketItemUUID: string;
  quantity: number;
  price: number;
  comment?: string;
  itemUUID: string;
  itemName: string;
  sizeUUID: string;
  sizeName: string;
  extras: BasketExtraCategory[];
  error?: BasketItemErrorEnum;
  isTemp?: boolean;
}

/****** basket item data *******/

export interface ItemAggregate{
  uuid: string,
  data: ItemAggregateData
}

interface ItemAggregateData{
  availableForDelivery: boolean,
  availableInBranch: boolean,
  description?: string,
  extraCategories: ExtraCategoryAggregate[],
  liked: boolean,
  likesCount: number,
  name: string,
  photoUrl?: string,
  photos: string[],
  priceAvailable: boolean,
  sequence: number,
  sizes: SizeAggregate[],
  tags?: Tag[]
}

interface ExtraCategoryAggregate {
  uuid: string,
  data: ExtraCategoryAggregateData
}
interface ExtraCategoryAggregateData {
  availableFromDate: string,
  availableFromTime?: string,
  availableToDate: string,
  availableToTime: string,
  categoryType: string,
  description?: string,
  items: ItemAggregate[],
  maximumAllowedExtra: number,
  minimumAllowedExtra: number,
  name: string,
  sizeRestricted: boolean
}
interface SizeAggregate {
  uuid: string,
  sizeUUID: string,
  data: SizeAggregateData
}

interface SizeAggregateData {
  name: string,
  price: number
}

interface Tag {
  uuid: string,
  data: TagData
}

interface TagData {
  name:string,
  description?: string
}

/*****Extra Items Categorized*******/
interface BasketExtraCategory {
  categoryUUID: string;
  categoryName: string;
  extraItems: BasketExtraItem[];
}
interface BasketExtraItem {
  basketItemExtraUUID: string;
  price: number;
  itemUUID: string;
  itemName: string;
  sizeUUID: string;
  sizeName: string;
}
/*****Errors Enums*******/
enum BasketItemErrorEnum {
  "ITEM_UNAVAILABLE_IN_BRANCH",
  "ITEM_UNAVAILABLE_NOW",
  "ITEM_UNAVAILABLE_FOR_DELIVERY",
  "ITEM_PRICE_CHANGE"
}
enum BasketErrorEnum {
  "BRANCH_IS_NOT_OPEN",
  "BRANCH_IS_NOT_DELIVERING",
  "BRANCH_DO_NOT_COVER_ZONE",
  "BELOW_MINIMUM_ORDER_VALUE"
}
export enum genericErrorsEnum {
  internet = "INTERNET",
  generic = "GENERIC", 
  item = "ITEM"
}

enum PaymentTypeEnum {
  CASH_ON_DELIVERY,
  CREDIT_CARD
}
/*************End Basket Data*************/

/*****Compact Basket[Counter]*******/
export interface BasketCompact {
  
  uuid: string;
  ref: BasketCompactRef;
  data: BasketCompactData;
  loading?:boolean;
}
interface BasketCompactRef {
  restaurantUUID: string;
}
interface BasketCompactData {
  totalPrice: number;
  subTotal:number;
  itemCount: number;
  isGroup:boolean;
  isLocked:boolean;
  restaurantName:string;
}

/*********Requests[items sent to api]**********/
interface OrderRequest {
  branchUUID: string;
  userAddressUUID: string;
  items: OrderItemRequest[];
  location?: Location;
}
export interface OrderItemRequest {
  itemSizeUUID: string;
  quantity: number;
  extras: ItemExtraCategoryRequest[];
  comment?: string;
}


interface ItemExtraCategoryRequest {
  extraCategoryUUID: string;
  extraItemSizesUUIDs: string[];
}

export interface CreateBasketRequest {
  restaurantUUID: string;
  branchUUID: string;
  zoneUUID: string;
  firstItem: OrderItemRequest;
}

/************** BASKETE STATE***************/
export interface UserBasketStateRequest{
  restaurantUUID: string,
  basketUUID?: string
}

enum UserBasketStateEnum {
  "NO_BASKET", 
  "HAS_BASKET_IN_THIS_RESTAURANT", 
  "HAS_BASKET_IN_ANOTHER_RESTAURANT", 
  "MEMBER_IN_ANOTHER_GROUP", 
  "MEMBER_IN_THIS_GROUP"
}

/************** GROUP BASKET ****************/
export interface CreateGroupBasketRequest{
  restaurantUUID: string;
  branchUUID: string;
  zoneUUID: string;
}


interface GroupBasketRef {
  restaurant: BasketRestaurant,
  branch: BasketBranch,
  adminUserUUID:string,
  zoneUUID: string
  promo?: {
    code:string
  }
}

export interface GroupBasketUser {
  username: string,
  userUUID: string,
  totalPrice: number,
  categories: BasketCategory[],
}

interface GroupBasketData {
  link: string,
  receipt: Receipt,
  minimumOrderValue: number,
  isLocked: boolean,
  error?: BasketErrorEnum,
  users: GroupBasketUser[],
}

export interface GroupBasket {
  visible:boolean
  uuid: string
  itemsCount:number
  ref: GroupBasketRef
  data: GroupBasketData
}

/** update basket payment method request **/
interface BasketPaymentRequest{
  payment: PaymentTypeEnum
  cardUUID?: string
}